<template>
    <div>
        <Table
            ref="table"
            border
            stripe
            :columns="columns"
            :data="data"
            :height="height"
            size="small"
            :loading="loading"
            :show-summary="isSummary"
            @on-select-cancel="onUnSelect"
            @on-selection-change="onSelect"
            @on-row-dblclick="handleRowClick"
        ></Table>
        <footer>
            <slot name="footer"></slot>
        </footer>
        <Page
            v-if="total !== 0"
            show-sizer
            show-total
            show-elevator
            :current="pageIndex"
            :total="total"
            :page-size="pageSize"
            :page-size-opts="pageSizeOptions"
            @on-change="onPageChange"
            @on-page-size-change="onPageSizeChange"
            size="small"
            style="margin-top:10px;text-align: right;"
        ></Page>
    </div>
</template>
<script>
export default {
    props: {
        columns: {
            type: Array,
            default: () => {
                return [];
            }
        },
        data: {
            type: Array,
            default: () => {
                return [{}];
            }
        },
        height: {
            type: Number,
            default: window.innerHeight - 170
        },

        loading: {
            type: Boolean,
            default: false
        },

        pageIndex: {
            type: Number,
            default: 1
        },

        total: {
            type: Number,
            default: 0
        },
        pageSize: {
            type: Number,
            default: 15
        },
        pageSizeOptions: {
            type: Array,
            default: () => {
                return [15, 20, 30, 40];
            }
        },
        isSummary:{
            type: Boolean,
            default: false
        }
    },
    methods: {
        onSelect(value) {
            this.$emit("onSelect", value);
        },
        handleRowClick(value) {
            this.$emit("handleRowClick", value);
        },
        cancelSelectAll() {
            this.$refs.table.selectAll(false);
        },
        onPageChange(value) {
            this.$emit("onPageChange", value);
        },
        onPageSizeChange(value) {
            this.$emit("onPageSizeChange", value);
        },
        onUnSelect(selection, row) {
            this.$emit("onUnSelectSelection", selection);
            this.$emit("onUnSelectRow", row);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/components/VTable/index.vue